
import { defineComponent } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
// import 'swiper/css';

import { TopNewsSwiperComponentSetup } from '@/components/TopNewsSwiperComponentBase';

export default defineComponent({
  name: 'PcTopNewsSwiperComponent',
  components: {
    Swiper,
    SwiperSlide
  },  
  setup() {
    return TopNewsSwiperComponentSetup();
  }
});
